// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__diikd","calendarButtons":"ClockData_calendarButtons__1oV1k"};